// @flow
import createReceiveMessage from "./receiveMessage";

export function initBroadcast(store: any) {
  window.onstorage = createReceiveMessage(store);
}
